<div class="loading" [hidden]="!loading">
  <div class="loader">Loading...</div>
</div>
<h2 class="mb-4"[hidden]="loading">Xero Integration</h2>
<div *ngIf="integrationStep == 1">
  <p>
    You can use Client Hub to automatically create Client Tasks for
    uncategorized expenses. You will be able to connect to Xero and select
    a client Xero company for this function.
  </p>

  <div class="action-wrapper">
    <div class="row d-flex align-items-center">
      <div class="col-sm-5">
        <!-- <input
          [(ngModel)]="selectedWorkspace"
          [typeahead]="availableWorkspaces | activeClientsOnly"
          typeaheadOptionField="name"
          (typeaheadOnSelect)="selectWorkspace($event)"
          [typeaheadOptionsLimit]="9999"
          [typeaheadMinLength]="0"
          placeholder="Map to an existing workspace"
          class="form-control chevron"
        /> -->
        <button class="btn btn-primary" (click)="openXeroIntegrationWizard()">Connect Xero Account</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="integrationStep == 2">
  <!-- <h3>
    Authenticate in Xero to select a company and choose the uncategorized
    account for it
  </h3> -->
  <p>
    You can use Client Hub to automatically create Client Tasks for
    uncategorized expenses. Below you can manage client Xero companies
    integration.
  </p>
  <div class="add-another-qb-company mb-3" (click)="selectedWorkspace = null; openXeroIntegrationWizard()">
    <i class="feather plus"></i>
    <span>Add Another Xero company</span>
  </div>
  <table class="table table-borderless table-striped">
    <thead>
      <tr>
        <th>Client Hub Workspace</th>
        <th>Xero Company</th>
        <th>Xero Uncategorized Account</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let entry of connectedWorkspaces; let i = index">
        <td>{{ entry.company_name }}</td>
        <td>
          <span *ngIf="entry.tenant_name else launchPopUp">{{ entry.tenant_name }}</span>
          <ng-template #launchPopUp>
            <a (click)="launchAuthenticationForm(entry.company)">Connect to Xero</a>
          </ng-template>
        </td>
        <td><button *ngIf="entry.tenant_name" (click)="manageAccounts(entry.uuid)">Manage Accounts</button></td>
        <td>
          <a
            class="color-red-hover"
            *ngIf="entry.tenant_name"
            (click)="disconnectWorkspaceConfirmationModal(entry.uuid, entry.company_name)"
          >
            <i class="feather trash visible-xs"></i
            ><span class="hidden-xs">Remove</span>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
